import React from 'react';

import { useBooking } from '@/booking';
import { IBookingInstance } from '@/booking/models';
import { IHotelModelInstance } from '@/hotel';
import { useTranslation } from '@/i18n';
import { AlertCard } from '@/ui/layout';
import { Spacer } from '@/ui/spacing';
import { useTheme } from '@/ui/theme';
import { Text } from '@/ui/typography';

export const AddOnDisclaimer = ({
  bookingId,
  hotelReferenceId,
}: {
  hotelReferenceId: IHotelModelInstance['referenceId'];
  bookingId: IBookingInstance['id'];
}) => {
  const { t } = useTranslation('additionalInformation');
  const booking = useBooking({ hotelSlug: hotelReferenceId, bookingId });
  const {
    componentProperties: { addOnCard: addOnCardStyles },
  } = useTheme();

  return (
    <AlertCard type="info" css={addOnCardStyles?.disclaimer}>
      <Text style="heading6" css={addOnCardStyles?.disclaimer?.warning}>
        {t('addOns.disclaimer')}
      </Text>
      <Spacer s="xxs" />
      <Text
        style="bodySmall"
        css={{ fontWeight: 700, ...addOnCardStyles?.disclaimer?.rateName }}
      >
        {booking?.firstRoomStay.firstRatePlan.rateName}
      </Text>
      {booking?.firstRoomStay.firstRatePlan.rateDescription.map(
        (description, index) => (
          <Text
            key={index}
            style="bodySmall"
            css={addOnCardStyles?.disclaimer?.rateDescription}
          >
            {description}
          </Text>
        )
      )}
    </AlertCard>
  );
};
